export const LOCALE = 'fr';

// langues de base ont tous les messages + possibilités de traduction
// éventuellement peuvent être surchargées par les pays spécifiques

export const TRANSLATIONS = new Map(
  Object.entries({
    'menu.tableau': 'Tableau de bord',
    'menu.accueil': 'Accueil',
    'menu.utilisateurs': 'Utilisateurs',
    'menu.distributeurs': 'Distributeurs',
    'menu.campagnes': 'Campagnes',
    'menu.exploitations': 'Mes exploitations',
    'menu.parcelles': 'Mes parcelles',
    'menu.commandes': 'Mes commandes',
    'menu.planning': 'Mon planning',
    'menu.conseils': 'Mes conseils',
    'menu.machinisme': 'Machinisme',
    'menu.exports': 'Exports',
    'menu.visualizer': 'Mon visualiseur',
    'login.profil': 'Profil',
    'login.logout': 'Fermer la session',

    'home.welcome': (name: string) => `Bienvenue sur votre espace ${name},`,
    'home.subwelcome.html': "Votre outil de <b>pilotage</b> et de <b>modulation</b> d'azote sur céréales et colza.",
    'home.contactus': "N'hésitez pas à nous contacter :",
    'home.tel.html': (tel: string) => `par téléphone au <b>${tel}</b>`,
    'home.mail.html': (mail: string) => `par mail à l'adresse <b>${mail}</b>`,
    'home.openhours.week': 'lundi-vendredi : 8h-18h',
    'home.openhours.weekend': 'samedi : 9h-17h',

    'me.profile': 'Mon profil',
    'me.login': 'Login',
    'me.nom': 'Nom',
    'me.distributeur': 'Distributeur',
    'me.roles': 'Rôles',
    'me.pays': 'Pays',
    'me.tel': 'Téléphone',
    'me.mobile': 'Mobile',
    'me.conseiller': 'Conseiller',
    'me.conseiller.email': 'Email du conseiller',
    'me.conseiller.mobile': 'Mobile du conseiller',

    'me.section': 'Profil',
    'me.edit.titre': 'Edition du profile',
    'me.edit.login': 'Login',
    'me.edit.email': 'Email de contact',
    'me.edit.distributeur': 'Distributeur',
    'me.edit.prenom': 'Prénom',
    'me.edit.nom': 'Nom',
    'me.edit.pays': 'Pays',
    'me.edit.tel': 'Téléphone',
    'me.edit.indicatif': 'Indicatif',
    'me.edit.numero': 'Numéro',
    'me.edit.mobile': 'Mobile',
    'me.edit.newmdp': 'Nouveau mot de passe',
    'me.edit.mdp': 'Mot de passe',
    'me.edit.mdpconfirm': 'Confirmation du mot de passe',
    'me.edit.mpdconfirm.error': 'Les mots de passe ne correspondent pas',

    'langue.edit': 'Edition de la langue',
    'langue.edit.distrPays': 'Pays du distributeur',
    'langue.edit.distrDefaultLang': '(langue par défaut du distributeur)',
    'langue.edit.languageGui': "Langue de l'interface",
    'langue.edit.languagePdf': 'Langue des PDF',
    'langue.edit.langue': 'Langue',
    'langue.edit.reloadWarning': "L'interface se rechargera après confirmation de ce dialogue",

    'distributeur.section': 'Distributeurs',
    'distributeur.table.filter.nom': 'nom du distributeur',
    'distributeur.table.button.add': 'Ajouter un distributeur',
    'distributeur.table.nom': 'Nom',
    'distributeur.table.none': 'Aucun distributeur à afficher',

    'distributeur.edit.creation': "Ajout d'un nouveau distributeur",
    'distributeur.edit.edition': 'Edition du distributeur',
    'distributeur.edit.nom': 'Nom',
    'distributeur.edit.responsable': 'Responsable(s) de distributeur',
    'distributeur.edit.sector': 'Responsable de secteur',
    'distributeur.edit.negoce': "Responsable de centrale d'achat",
    'distributeur.edit.logo': 'Envoyer le logo',
    'distributeur.edit.adresse': 'Adresse',
    'distributeur.edit.adrComp': "Complément d'adresse",
    'distributeur.edit.cp': 'Code postal',
    'distributeur.edit.ville': 'Ville',
    'distributeur.edit.pays': 'Pays',
    'distributeur.edit.tel': 'Téléphone',
    'distributeur.edit.i18n':
      'Internationalisation (changement de langue pour les utilisateurs) - langue par défaut sinon',
    'distributeur.edit.beapi': 'Client BeAPI',
    'distributeur.edit.unauthorized': "Vous n'êtes pas autorisé à modifier ce distributeur",
    'distributeur.edit.view.unauthorized': "Vous n'êtes pas autorisé à consulter ce distributeur",

    'user.section': 'Utilisateurs',
    'user.table.filter.nom': 'nom, prénom ou email',
    'user.table.filter.distributeur': 'nom du distributeur',
    'user.table.filter.conseiller': 'login du conseiller',
    'user.table.button.add': 'Ajouter un utilisateur',
    'user.table.login': 'Login',
    'user.table.nom': 'Nom',
    'user.table.distributeur': 'Distributeur',
    'user.table.role': 'Rôle',
    'user.table.referent': 'Référent',

    'user.edit.creation': "Ajout d'un nouvel utilisateur",
    'user.edit.edition': "Modification de l'utilisateur",
    'user.edit.login': 'Email (login)',
    'user.edit.login.placeholder': 'Email',
    'user.edit.email': 'Email de contact',
    'user.edit.prenom': 'Prénom',
    'user.edit.nom': 'Nom',
    'user.edit.pays': 'Pays',
    'user.edit.tel': 'Téléphone',
    'user.edit.indicatif': 'Indicatif',
    'user.edit.numero': 'Numéro',
    'user.edit.mobile': 'Mobile',
    'user.edit.roleWanaka': 'Rôle Wanaka',
    'user.edit.roleDistr': 'Rôle distributeur',
    'user.edit.role': 'Rôle',
    'user.edit.distributeur': 'Distributeur',
    'user.edit.manager.farmer': 'Conseiller',
    'user.edit.manager.conseiller': 'Responsable',
    'user.edit.unauthorized': "Vous n'êtes pas autorisé à modifier cet utilisateur",
    'user.edit.error.exists_in_db': "Impossible de créer l'utilisateur : un compte avec l'email donné existe déjà",
    // FIXME remplacer WANAKA par chaine WL (était comme ça avant)
    'user.edit.error.exists_in_kc': "Impossible de créer l'utilisateur : veuillez contacter votre support WANAKA",
    'user.edit.view.unauthorized': "Vous n'êtes pas autorisé à consulter cet utilisateur",

    'farm.section': 'Exploitations',
    'farm.table.filter.nom': "nom de l'exploitation",
    'farm.table.filter.distributeur': 'nom du distributeur',
    'farm.table.filter.conseiller': 'login du conseiller',
    'farm.table.button.add': 'Ajouter une exploitation',
    'farm.table.none': 'Aucune exploitation à afficher',
    'farm.table.nom': 'Nom',
    'farm.table.ville': 'Ville',
    'farm.table.cp': 'CP',
    'farm.table.login': 'Login',
    'farm.table.delete.error': 'Cette exploitation ne peut pas être supprimée',

    'farm.edit.creation': "Ajout d'une nouvelle exploitation",
    'farm.edit.edition': "Edition de l'exploitation",
    'farm.edit.proprietaire': 'Propriétaire',
    'farm.edit.nom': 'Nom',
    'farm.edit.fms': 'Identifiant FMS',
    'farm.edit.adresse': 'Adresse',
    'farm.edit.adrComp': "Complément d'adresse",
    'farm.edit.cp': 'Code postal',
    'farm.edit.ville': 'Ville',
    'farm.edit.pays': 'Pays',
    'farm.edit.siret': 'SIRET (facultatif)',
    'farm.edit.siret.placeholder': 'SIRET',
    'farm.edit.idDistr': 'Identifiant distributeur (facultatif)',
    'farm.edit.idDistr.placeholder': 'Identifiant distributeur',
    'farm.edit.unauthorized': "Vous n'êtes pas autorisé à modifier cette exploitation",
    'farm.edit.view.unauthorized': "Vous n'êtes pas autorisé à consulter cette exploitation",

    'parcel.section': 'Parcelles',
    'parcel.table.textTop':
      'Cette page vous permet de créer et de dessiner vos parcelles. Une fois celles-ci créées, pour commander un conseil (Colza, Blé, Orge), rendez-vous dans le menu Mes commandes.',
    'parcel.table.filter.parcelle': 'parcelle',
    'parcel.table.filter.exploitation': 'exploitation',
    'parcel.table.filter.id': 'identifiant',
    'parcel.table.filter.conseiller': 'Conseiller',
    'parcel.table.filter.conseiller.placeholder': 'login du conseiller',
    'parcel.table.filter.culture': 'Culture',
    'parcel.table.filter.campagne': 'Campagne',
    'parcel.table.filter.distributeur': 'Distributeur',
    'parcel.table.filter.facturation': 'Facturation',
    'parcel.table.filter.facturation.choice.facturer': 'à facturer',
    'parcel.table.filter.facturation.choice.nePasFacturer': 'à ne pas facturer',
    'parcel.table.button.add': 'Créer une parcelle',
    'parcel.table.parcelsBatch.tooltip':
      "Ces boutons permettent d'effectuer la même action sur TOUTES les parcelles filtrées",
    'parcel.table.downloadKML': 'Télécharger tous les KML',
    'parcel.table.none': 'Aucune parcelle à afficher',
    'parcel.table.nom': 'Nom',
    'parcel.table.exploitation': 'Exploitation',
    'parcel.table.culture': 'Culture',
    'parcel.table.surface': 'Surface',
    'parcel.table.campagne': 'Campagne',
    'parcel.table.complete': 'Complet',
    'parcel.table.imgOK.alt': 'complété',
    'parcel.table.imgOK.title': 'Parcelle complète',
    'parcel.table.imgWarning.alt': 'non complété',
    'parcel.table.imgWarning.title': 'Parcelle incomplète',
    'parcel.table.button.reuse': 'Réutiliser',
    'parcel.table.button.reuse.tooltip': 'Réutiliser ces contours pour définir une parcelle pour la campagne en cours',
    'parcel.table.button.edit': 'Editer la parcelle',
    'parcel.table.button.delete': 'Supprimer définitivement la parcelle',

    'parcel.edit.creation': "Création d'une nouvelle parcelle",
    'parcel.edit.edition': 'Edition de la parcelle',
    'parcel.edit.campagne': 'Campagne',
    'parcel.edit.exploitation': 'Exploitation',
    'parcel.edit.exploitation.loading': 'Chargement des exploitations...',
    'parcel.edit.nom': 'Nom de la parcelle',
    'parcel.edit.nom.placeholder': 'Nom',
    'parcel.edit.cp': 'Code postal',
    'parcel.edit.pays': 'Pays',
    'parcel.edit.ville': 'Ville (facultatif)',
    'parcel.edit.ville.placeholder': 'Ville',
    'parcel.edit.pac': 'Numéro Ilot PAC (facultatif)',
    'parcel.edit.pac.placeholder': 'Numéro Ilot PAC',
    'parcel.edit.fms': 'Identifiant FMS',
    'parcel.edit.idDistr': 'Identifiant distributeur (facultatif)',
    'parcel.edit.idDistr.placeholder': 'Identifiant distributeur',
    'parcel.edit.culture': 'Culture',
    'parcel.edit.culture.restricted':
      'La culture ne peut pas être modifiée car la parcelle a déjà une commande associée',
    'parcel.edit.destination': 'Destination',
    'parcel.edit.variete': 'Variété principale',
    'parcel.edit.variete.all': 'Toutes',
    'parcel.edit.variete.autre': 'Autre',
    'parcel.edit.variete.melange': 'Mélange de variétés',
    'parcel.edit.variete.cultureWarning': "Renseigner d'abord la culture",
    'parcel.edit.precedent': 'Précédent cultural',
    'parcel.edit.precedent.placeholder': 'Précédent',
    'parcel.edit.jachere': 'Type de jachère',
    'parcel.edit.ageJachere': 'Age de jachère',
    'parcel.edit.devenir': 'Devenir du précédent',
    'parcel.edit.devenir.placeholder': 'Devenir',
    'parcel.edit.sol': 'Sol',
    'parcel.edit.sol.cpWarning': "Renseigner d'abord le code postal et le pays",
    'parcel.edit.sol.cpError': 'Code postal non reconnu !',
    'parcel.edit.profondeur': 'Profondeur du sol',
    'parcel.edit.profondeur.placeholder': 'Profondeur',
    'parcel.edit.dateSemis': 'Date de semis',
    'parcel.edit.noFacturation': 'Conseil à ne pas facturer',
    'parcel.edit.geometry.warning': "N'oubliez pas de dessiner votre parcelle !",
    'parcel.edit.geometry.instructions.html':
      "<label><b>Veuillez dessiner votre parcelle : </b></label><label>- recherchez la zone géographique à l'aide de la loupe </label><label>- cliquez sur l'icône du polygone sur la carte pour commencer à définir le contour </label><label>- double-cliquez pour valider votre contour </label> <label>- <b>pour un détourage simplifié, affichez et utilisez le RPG</b></label>",
    'parcel.edit.geometry.import': 'Importer un contour au format KML',
    'parcel.edit.importData': 'Importer des données de terrain depuis Climate Fieldview',
    'parcel.edit.geometry.import.error': 'Format de KML non pris en charge.',
    'parcel.edit.geometry.surfaceError':
      'Attention seules les parcelles avec une surface supérieure à 1 hectare peuvent être commandées.',
    'parcel.edit.surface': 'Surface',
    'parcel.edit.unauthorized': "Vous n'êtes pas autorisé à modifier cette parcelle",
    'parcel.edit.view.unauthorized': "Vous n'êtes pas autorisé à consulter cette parcelle",
    'parcel.edit.error':
      'Il y a des erreurs dans le formulaire : merci de supprimer le détourage et de le retracer intégralement manuellement sans passer par le RPG',
    'parcel.edit.map.showRPG': 'Afficher le Registre Parcellaire Graphique 2024',
    'parcel.edit.map.contour': 'Utiliser ce contour',
    'parcel.edit.map.searchAddress': 'Rechercher une adresse',
    'parcel.edit.map.selectContour': 'Cliquer pour sélectionner directement votre parcelle',
    'parcel.edit.map.showAutresParcelles': "Afficher les autres parcelles de l'exploitation",

    'parcel.dialog.title': 'Détails de la parcelle',
    'parcel.dialog.nom': 'Nom',
    'parcel.dialog.pac': 'N° Ilot PAC',
    'parcel.dialog.cp': 'Code postal',
    'parcel.dialog.ville': 'Ville',
    'parcel.dialog.pays': 'Pays',
    'parcel.dialog.exploitation': 'Exploitation',
    'parcel.dialog.culture': 'Culture',
    'parcel.dialog.destination': 'Destination',
    'parcel.dialog.variete': 'Variété',
    'parcel.dialog.precedent': 'Précédent',
    'parcel.dialog.jachere': 'Type de jachère',
    'parcel.dialog.ageJachere': 'Age de jachère',
    'parcel.dialog.devenir': 'Devenir du précédent',
    'parcel.dialog.sol': 'Sol',
    'parcel.dialog.profondeur': 'Profondeur du sol',
    'parcel.dialog.dateSemis': 'Date de semis',
    'parcel.dialog.campagne': 'Campagne',
    'parcel.dialog.surface': 'Surface',
    'parcel.dialog.import': 'Importer',

    'parcel.delete.confirm.title': 'Confirmation',
    'parcel.delete.confirm.question': (
      parcelText: string,
    ) => `Confirmez vous la suppression de la parcelle ${parcelText} ?<br>
    La suppression de la parcelle entrainera la suppression des informations qui auraient été renseignées pour la ou les commandes associées.`,

    'map.dessin': 'Dessiner une parcelle',
    'map.cancel': 'Annuler le dessin',
    'map.cancel.short': 'Annuler',
    'map.terminer': 'Terminer le dessin',
    'map.supprDernierPoint': 'Supprimer le dernier point',
    'map.clicCommencer': 'Cliquer pour commencer le dessin',
    'map.clicPoursuivre': 'Cliquer pour poursuivre le dessin',
    'map.clicPremierPoint': 'Cliquer sur le premier point pour finir le dessin',
    'map.sauver': 'Sauvegarder',
    'map.suppr': 'Supprimer',
    'map.modifier': 'Modifier une parcelle',
    'map.noParcelle': 'Aucune parcelle à modifier',
    'map.clicPointsMove': 'Cliquer sur les points pour les déplacer',
    'map.clicCancel': 'Cliquer sur annuler pour enlever les changements',
    'map.supprParcelle': 'Supprimer une parcelle',
    'map.noParcelleSuppr': 'Aucune parcelle à supprimer',
    'map.clicParcelleSuppr': 'Cliquer sur la parcelle pour la supprimer',
    'map.intersection': "Pas d'intersection autorisée !",
    'map.zoomIn': 'Zoomer',
    'map.zoomOut': 'Dézoomer',

    'fieldview.button.connect': 'Lier votre compte à FieldView',
    'fieldview.connect.wait': 'La connexion est en cours...',
    'fieldview.connect.success': 'Connexion avec FieldView réussie.',
    'fieldview.connect.error': 'Erreur lors de la connexion, veuillez contacter le support client.',
    'fieldview.button.disconnect': 'Se déconnecter de FieldView',
    'fieldview.disconnect.success': 'Votre compte a bien été déconnecté de Fieldview',
    'fieldview.disconnect.error': 'Echec lors de la suppression du lien Fieldview',

    'fieldview.table.name': 'Nom',
    'fieldview.table.id': 'Id',
    'fieldview.table.import': 'Importer',
    'fieldview.dialog.title': 'FieldView Parcelles',

    'orders.title': 'Mes commandes',
    'orders.view': 'Consulter',
    'orders.arcolza': 'Fumure azotée<br>COLZA',
    'orders.arcolza.imgAlt': 'Colza',
    'orders.arble': 'Fumure azotée<br>BLE',
    'orders.arble.imgAlt': 'Blé',
    'orders.arorge': 'Fumure azotée ORGE<br><small><small><small>Et modulation autres cultures *',
    'orders.arorge.imgAlt': 'Orge',
    'orders.arorge.asterisk':
      '* : Seigle, Triticale, Chanvre, Prairie (permanente, temporaire, Ray-Grass), Maïs, Pomme de terre, Lin',
    'orders.zsn': 'Densité<br>SEMIS',
    'orders.zsn.imgAlt': 'Densité de semis',

    'ar.button.sauverCommander': 'Enregistrer et commander',

    'ar.colza.section': 'Fumure azotée Colza',
    'ar.colza.table.eligible':
      'Les parcelles ci-dessous sont éligibles au traitement Fumure azotée Colza. Vous devez renseigner les informations pour le conseil, puis passer commande.',
    'ar.colza.table.filter.destination': 'Destination',

    'ar.colza.error.suppr': 'Impossible de supprimer les détails Colza',
    'ar.colza.error.varietes': 'Problème lors de la récupération des varietés',

    'ar.colza.edit.title.uneParcelle': 'Saisie des informations Colza - Parcelle',
    'ar.colza.edit.title.multiParcelles': 'Saisie des informations Colza pour les parcelles sélectionnées',
    'ar.colza.edit.conseil': 'Quel type de conseil souhaitez-vous ?',
    'ar.colza.edit.conseil.choice.zonage': 'Offre avec zonage',
    'ar.colza.edit.conseil.choice.simplifie': 'Offre simplifiée sans zonage (dose moyenne)',
    'ar.colza.edit.couvert': 'Le colza a-t-il un couvert associé ?',
    'ar.colza.edit.couvert.tooltip': 'Dans ce cas la mesure de biomasse en entrée hiver est impossible.',
    'ar.colza.edit.couvert.header': 'Couvert ?',
    'ar.colza.edit.objectif': 'Objectif de rendement (q/ha)',
    'ar.colza.edit.objectif.placeholder': 'Objectif',
    'ar.colza.edit.apportmo': 'Apports de matière organique',
    'ar.colza.edit.apportmo.hist': 'Historique des apports de matière organique',
    'ar.colza.edit.apportmo.hist.freq': "Fréquence d'apport",
    'ar.colza.edit.apportmo.hist.freq.header': 'Fréquence',
    'ar.colza.edit.apportmo.hist.produit': 'Produit généralement apporté',
    'ar.colza.edit.apportmo.hist.produit.header': 'Produit',
    'ar.colza.edit.apportmo.automne': "Produits organiques apportés à l'automne",
    'ar.colza.edit.apportmo.automne.1': '1er Apport',
    'ar.colza.edit.apportmo.automne.2': '2ème Apport',
    'ar.colza.edit.apportmo.automne.produit': 'Produit',
    // TODO voir conversion unités
    'ar.colza.edit.apportmo.automne.teneur': 'Teneur en azote (kgN/t)',
    'ar.colza.edit.apportmo.automne.1.teneur.placeholder': 'Teneur (1er Apport)',
    'ar.colza.edit.apportmo.automne.2.teneur.placeholder': 'Teneur (2ème apport)',
    'ar.colza.edit.apportmo.automne.quantite': 'Quantité de produit épandue (t/ha)',
    'ar.colza.edit.apportmo.automne.1.quantite.placeholder': 'Quantité de produit (1er Apport)',
    'ar.colza.edit.apportmo.automne.2.quantite.placeholder': 'Quantité de produit (2ème apport)',
    'ar.colza.edit.reliquat': "Disposez-vous d'une mesure de reliquat sortie hiver ?",
    'ar.colza.edit.reliquat.header': 'Reliquat ?',
    'ar.colza.edit.reliquat.mesure': 'Mesure du reliquat (unités)',
    'ar.colza.edit.reliquat.mesure.placeholder': 'Mesure reliquat',
    'ar.colza.edit.apport1SH': '1er apport minéral en Sortie Hiver (facultatif)',
    'ar.colza.edit.apport1SH.tooltip':
      'Remplissez ces informations si vous effectuez un 1er apport avant le pilotage, et si vous souhaitez moduler cet apport.',
    'ar.colza.edit.apport1SH.dose.1':
      'Dose (facultative) à apporter pour le 1er apport minéral en Sortie Hiver (unités).',
    'ar.colza.edit.apport1SH.dose.2': '(Cette dose sera déduite de la carte de modulation de la dose totale.)',
    'ar.colza.edit.apport1SH.dose.placeholder': "Dose d'azote",
    'ar.colza.edit.apport1SH.engraisMineralPrevu': 'Engrais minéral azoté prévu',
    'ar.colza.edit.dernierApportSH': 'Dernier apport minéral en Sortie Hiver',
    'ar.colza.edit.dernierApportSH.engraisMineralPrevu': 'Engrais minéral azoté prévu',
    'ar.colza.edit.carteepandage.choix':
      "Souhaitez vous recevoir une carte d'épandage basée sur la mesure de biomasse entrée hiver pour votre 1er apport ?",
    'ar.colza.edit.information.planning':
      'Veuillez consultez le menu "Mon planning" pour vérifier la période de restitution prévue et la modifier si besoin. Une modification de commande ne modifie pas la date de restitution enregistrée.',

    'ar.ble.section': 'Fumure azotée Blé',
    // identique au colza + orge pour l'essentiel
    // TODO en commun ?
    'ar.ble.table.eligible':
      'Les parcelles ci-dessous sont éligibles au traitement Fumure azotée Blé. Vous devez renseigner les informations pour le conseil, puis passer commande.',
    'ar.ble.table.filter.culture': 'Culture',
    'ar.ble.table.t1': 'Tallage',
    'ar.ble.table.t2': 'Début montaison',
    'ar.ble.table.verse': 'Verse',
    'ar.ble.table.2n': '2 noeuds',
    'ar.ble.table.t3': '3 noeuds ou DFE',

    'ar.ble.error.suppr': 'Impossible de supprimer les détails Blé',
    'ar.ble.error.cultures': 'Problème lors de la récupération des cultures',

    'ar.ble.edit.title.uneParcelle': 'Saisie des informations Blé - Parcelle',
    'ar.ble.edit.title.multiParcelles': 'Saisie des informations Blé pour les parcelles sélectionnées',
    'ar.ble.edit.contactSupport':
      "Si certains conseils sont inaccessibles, ou dans l'impossibilité de planifier, contacter le support client.",
    'ar.ble.edit.conseil': 'Quel type de conseil souhaitez-vous ?',
    'ar.ble.edit.warning.existing':
      'Un conseil est déjà disponible pour cette commande. Vous ne pouvez pas la modifier.',
    'ar.ble.edit.stade.choice.2n': '2N',
    'ar.ble.edit.stade.choice.3n': '3N',
    'ar.ble.edit.stade.choice.dfe': 'DFE',
    'ar.ble.edit.4passages': '4 passages (Tallage, Début montaison, pilotage 2N, pilotage DFE)',
    'ar.ble.edit.4passages.warning':
      "Le nombre de passages et de pilotages d'un type de conseil n'est pas modifiable. Il est toutefois possible de modifier le type de conseil après avoir passé la commande.",
    'ar.ble.edit.bleTallage.warning': 'Les commandes Blé Tallage sont terminées',
    'ar.ble.edit.3passages': '3 passages (Tallage, Début montaison, pilotage fin montaison)',
    'ar.ble.edit.2passages': '2 passages (Début montaison, pilotage fin montaison)',
    'ar.ble.edit.bleDebutMontaison.warning': 'Les commandes Blé Début montaison sont terminées',
    'ar.ble.edit.1passage': '1 passage (pilotage fin montaison)',
    'ar.ble.edit.bleFinMontaison.warning': 'Les commandes Blé Pilotage fin montaison sont terminées',
    'ar.ble.edit.zonage': 'Souhaitez-vous une modulation de votre conseil en intra-parcellaire ?',
    'ar.ble.edit.zonage.tooltip':
      "Le conseil sans modulation est uniquement disponible avec l'offre 1 passage (pilotage fin montaison). Avec cette offre simplfiée, il n'est pas possible de demander un fichier console par la suite.",
    'ar.ble.edit.zonage.non':
      'Non - pas de zonage intra-parcellaire - conseil simplifié (ATTENTION choix possible uniquement avec 1 seul passage)',
    'ar.ble.edit.zonage.oui.mobile':
      "Oui - disponible sur l'application mobile et les restitutions PDF (3 zones maximum)",
    'ar.ble.edit.zonage.oui.manual': 'Oui - version console manuelle - type barre de guidage (3 zones maximum)',
    'ar.ble.edit.zonage.oui.auto': 'Oui - version console automatique (6 zones maximum)',
    'ar.ble.edit.zonage.warning':
      "Attention : cette offre simplifiée n'inclut ni zonage ni modulation intra-parcellaire (dose moyenne uniquement).",

    'ar.ble.edit.engrais': 'Engrais minéral azoté prévu',
    'ar.ble.edit.engrais.dose.placeholder': "Dose d'azote",

    'ar.ble.edit.tallage': 'Apport au stade Tallage',
    'ar.ble.edit.tallage.dose': 'Dose à moduler au stade Tallage (unités)',
    'ar.ble.edit.tallage.dose.tooltip':
      "Indiquez la dose d'azote que vous avez prévu d'apporter au stade tallage selon votre fractionnement.",

    'ar.ble.edit.debutMontaison': 'Apport au stade Début montaison',
    'ar.ble.edit.debutMontaison.dose': 'Dose à moduler au stade début montaison (unités)',
    'ar.ble.edit.debutMontaison.dose.tooltip':
      "Indiquez la dose d'azote que vous avez prévu d'apporter au stade début montaison selon votre fractionnement.",
    'ar.ble.edit.debutMontaison.verse': 'Risque de verse',

    'ar.ble.edit.2n': 'Apport Pilotage 2N',
    'ar.ble.edit.2n.infoText.html': `Afin de réaliser le conseil pour l'apport d'azote en pilotage 2N, vous devrez indiquer les
    informations suivantes:

    <ul>
    <li>la forme et la concentration en azote de l'engrais qui sera appliqué</li>
    <li>les références de la console de modulation le cas échéant</li>
    </ul>

    Ces informations vous seront redemandées avant la réalisation du conseil.`,
    'ar.ble.edit.2n.noInfo':
      "Aucune information supplémentaire n'est nécessaire pour la réalisation du conseil Pilotage 2N.",

    'ar.ble.edit.3nDfe': 'Apport Pilotage 3N ou DFE',
    'ar.ble.edit.3nDfe.infoText.html': `Afin de réaliser le conseil pour l'apport d'azote en pilotage 3N ou DFE, vous devrez indiquer les
    informations suivantes:

    <ul>
      <li>la forme et la concentration en azote de l'engrais qui sera appliqué</li>
      <li>les références de la console de modulation le cas échéant</li>
    </ul>

    Ces informations vous seront redemandées avant la réalisation du conseil.`,
    'ar.ble.edit.3nDfe.noInfo':
      "Aucune information supplémentaire n'est nécessaire pour la réalisation du conseil Pilotage 3N ou DFE.",
    'ar.ble.edit.3nDfe.info': 'Informations facultatives',
    'ar.ble.edit.3nDfe.dose.pre':
      "Doses déjà apportées (tous apports confondus) avant l'apport prévu en pilotage 3N ou DFE (unités)",
    'ar.ble.edit.3nDfe.dose.dernier': 'Dont un dernier apport réalisé de (unités)',
    'ar.ble.edit.3nDfe.dose.dernier.placeholder': "Dose d'azote dernier apport",
    'ar.ble.edit.3nDfe.dose.dernier.date': 'Effectué le (date du dernier apport réalisé)',
    'ar.ble.edit.dose.dernier.date.noDate': 'Non renseigné',
    'ar.ble.edit.information.t1':
      'Si votre culture présente un stress de nutrition, une dose de 40 U suffit à sa reprise de végétation sortie hiver. Pour rappel, l’azote ne fait pas taller et un excès d’azote au tallage nuit à une bonne performance économique.',
    'ar.ble.edit.information.t2':
      "L’apport début montaison constitue l’apport principal, soit de 60 % à 80 % de l’apport total. Pour l’efficacité de votre apport, il est conseillé de ne pas dépasser 40 à 60 unités d’azote par apport. \
      Au-delà, il est préférable de fractionner votre apport. L'apport de plus de 100 unités en une seule fois est strictement interdit en zone directive nitrate.",
    'ar.ble.edit.information.planning':
      'Veuillez consultez le menu "Mon planning" pour vérifier la période de restitution prévue et la modifier si besoin. Une modification de commande ne modifie pas la date de restitution enregistrée.',

    'ar.ble.edit.objectif': 'Objectif de rendement (q/ha)',
    'ar.ble.edit.objectif.placeholder': 'Objectif',
    'ar.ble.edit.objectif.tooltip':
      'Prenez la moyenne des rendements de la culture réalisés dans des conditions comparables de sol au cours des 5 dernières années, en enlevant l’année la plus haute et l’année la plus basse.',

    'ar.ble.edit.doseppf': 'Dose prévisionnelle calculée (unités)',
    'ar.ble.edit.doseppf.placeholder': 'Dose prévisionnelle',
    'ar.ble.edit.doseppf.tooltip':
      'Indiquez la dose d’azote totale obtenue avec votre outil en unités par hectare si le calcul a déjà été réalisé. Dans le cas contraire, vous pouvez valider votre commande et renseigner cette information ultérieurement.',

    'ar.ppf.conseil':
      "En complément de votre(vos) conseil(s), souhaitez-vous bénéficier d'un plan prévisionnel de fumure (PPF) ?",
    'ar.ppf.conseil.warning':
      "Attention : ce plan prévisionnel est fourni à titre informatif et n'est pas réglementaire. En enregistrant cette commande, j'accepte avoir pris connaissance de cette information.",
    'ar.orge.section': 'Fumure azotée Orge',
    'ar.orge.table.eligible':
      'Les parcelles ci-dessous sont éligibles au traitement Fumure azotée Orge ou à la modulation autres cultures. Vous devez renseigner les informations pour le conseil, puis passer commande.',
    'ar.orge.table.filter.culture': 'Culture',
    'ar.orge.table.ppf': 'PPF',
    'ar.orge.table.t1': 'Tallage',
    'ar.orge.table.t2': 'Début montaison',
    'ar.orge.table.t3': 'Fin montaison',

    'ar.orge.error.suppr': 'Impossible de supprimer les détails Orge',
    'ar.orge.error.cultures': 'Problème lors de la récupération des cultures',

    'ar.orge.edit.title.uneParcelle': 'Saisie des informations Culture - Parcelle',
    'ar.orge.edit.title.multiParcelles': 'Saisie des informations pour les parcelles sélectionnées',
    'ar.orge.edit.contactSupport':
      "Si certains conseils sont inaccessibles, ou dans l'impossibilité de planifier, contacter le support client.",
    'ar.orge.edit.conseil': 'Quel type de conseil souhaitez-vous ?',
    'ar.orge.edit.3passages': '3 passages (Orge : Tallage, Début montaison, Fin montaison)',
    'ar.orge.edit.3passages.warning': 'Les commandes Orge Tallage sont terminées',
    'ar.orge.edit.2passages': '2 passages (Orge : Début montaison, Fin montaison)',
    'ar.orge.edit.2passages.warning': 'Les commandes Orge Début montaison sont terminées',
    'ar.orge.edit.1passage': '1 passage (Orge : Fin montaison)',
    'ar.orge.edit.1passage.warning': 'Les commandes Orge Fin montaison sont terminées',
    'ar.orge.admin.orderT1EndingOn': 'Date de fin de commande T1 :',
    'ar.orge.admin.dataT1EndingOn': 'Date de fin de saisie T1 :',
    'ar.orge.admin.notProvided': 'Non renseigné',
    'ar.orge.edit.tallage': 'Apport au stade Tallage',
    'ar.orge.edit.tallage.dose': 'Dose à moduler au stade Tallage (unités)',
    'ar.orge.edit.tallage.dose.tooltip':
      "Indiquez la dose d'azote que vous avez prévu d'apporter au stade tallage selon votre fractionnement.",
    'ar.orge.edit.information.t1':
      'Si votre culture présente un stress de nutrition, une dose de 40 U suffit à sa reprise de végétation sortie hiver. Pour rappel, l’azote ne fait pas taller et un excès d’azote au tallage nuit à une bonne performance économique.',
    'ar.orge.edit.debutMontaison': 'Apport au stade début montaison',
    'ar.orge.edit.debutMontaison.dose': 'Dose à moduler au stade début montaison (unités)',
    'ar.orge.edit.finMontaison': 'Apport au stade dernier apport fin montaison',
    'ar.orge.edit.finMontaison.dose': 'Dose à moduler au stade fin montaison (unités)',
    'ar.orge.edit.engrais': 'Engrais minéral azoté prévu',
    'ar.orge.edit.engrais.dose.placeholder': "Dose d'azote",
    'ar.orge.edit.pilotage': "Pour votre passage fin de montaison, souhaitez-vous un pilotage de la dose d'azote ?",
    // memes textes que pour le ble
    'ar.orge.edit.zonage': 'Souhaitez-vous une modulation de votre conseil en intra-parcellaire ?',
    'ar.orge.edit.zonage.non':
      'Non - pas de zonage intra-parcellaire - conseil simplifié (ATTENTION choix possible uniquement avec 1 seul passage)',
    'ar.orge.edit.zonage.oui.mobile':
      "Oui - disponible sur l'application mobile et les restitutions PDF (3 zones maximum)",
    'ar.orge.edit.zonage.oui.manual': 'Oui - version console manuelle - type barre de guidage (3 zones maximum)',
    'ar.orge.edit.zonage.oui.auto': 'Oui - version console automatique (6 zones maximum)',
    'ar.orge.edit.information.planning':
      'Veuillez consultez le menu "Mon planning" pour vérifier la période de restitution prévue et la modifier si besoin. Une modification de commande ne modifie pas la date de restitution enregistrée.',

    'ar.table.filter.parcelle.placeholder': 'parcelle',
    'ar.table.filter.exploitation.placeholder': 'exploitation',
    'ar.table.filter.id.placeholder': 'identifiant',
    'ar.table.filter.conseiller.placeholder': 'login du conseiller',
    'ar.table.filter.campagne': 'Campagne',
    'ar.table.filter.distr': 'Distributeur',
    'ar.table.filter.parcellesCompletes': 'Parcelles complètes',
    'ar.table.filter.parcellesCompletes.choice.complete': 'Complétées',
    'ar.table.filter.parcellesCompletes.choice.incomplete': 'Non complétées',
    'ar.table.filter.commande': 'Etat de commande',
    'ar.table.filter.commande.choice.commande': 'Commandé',
    'ar.table.filter.commande.choice.nonCommande': 'Non commandé',

    'ar.table.recap': 'Voir le récapitulatif des commandes validées',
    'ar.table.button.infoFill': 'Renseignez / Modifiez les données pour le conseil',
    'ar.table.button.removeOrder': 'Supprimer la commande',

    'ar.table.ordersBatch.tooltip':
      "Ces boutons vous permettent d'effectuer la même action sur TOUTES les parcelles sélectionnées (case cochée)",

    'ar.table.nom': 'Nom',
    'ar.table.exploitation': 'Exploitation',
    'ar.table.surface': 'Surface',
    'ar.table.commande': 'Commande',
    'ar.table.commande.eh': 'Entrée hiver',
    'ar.table.commande.sh': 'Sortie hiver',
    'ar.table.ref': 'Référence',
    'ar.table.beapi': 'BeApi',

    'ar.table.commande.complete.title': 'conseil commandé et saisie complète',
    'ar.table.commande.complete.alt': 'complété',
    'ar.table.commande.incomplet.title': 'conseil commandé mais données incomplètes',
    'ar.table.commande.incomplet.alt': 'non complété',
    'ar.table.commande.nc.text': 'NC',
    'ar.table.commande.beapi.commande.title': 'BeApi commandé',
    'ar.table.commande.beapi.commande.alt': 'commandé',

    'ar.table.error.recupParcellesDispo': 'Impossible de récupérer le nombre de parcelles disponibles',
    'ar.table.error.unauthorized': "Vous n'êtes pas autorisé à effecturer cette opération",
    'ar.table.error.selection': 'Impossible de sélectionner les parcelles',

    'ar.edit.editionLot': 'Edition par lot',
    'ar.edit.info.caseCochee':
      "Lorsque la case précédant l'information est cochée, cette information s'appliquera à l'ensemble des parcelles sélectionnées.",
    'ar.edit.beapi': 'BeAPI commandé (non éditable - rdv sur SMAG pour modification)',
    'ar.edit.choice.oui': 'Oui',
    'ar.edit.choice.non': 'Non',
    'ar.edit.console': 'Fichier console ',
    'ar.edit.console.tooltip':
      'Si vous êtes équipés de matériel permettant la modulation automatique, une carte au format informatique à insérer dans votre console vous est fournie. Pour cela, veuillez compléter les champs ci-dessous. Ces cartes peuvent aussi être lues sur une console de guidage. Les cartes pour la modulation automatique sont générées en 6 zones. Les cartes pour la modulation manuelle sont générées en 3 zones.',
    'ar.edit.error.pasDeParcelle': 'Pas de parcelle spécifiée',
    'ar.edit.error.invalidNumber': 'Il y a des nombres invalides dans le formulaire',
    'ar.edit.error.internal': 'Une erreur interne est survenue.',
    'ar.edit.error.unauthorized.edit': "Vous n'êtes pas autorisé à modifier cette parcelle",
    'ar.edit.error.unauthorized.edit.multiParcels': "Vous n'êtes pas autorisé à modifier ces parcelles",
    'ar.edit.error.unauthorized.view': "Vous n'êtes pas autorisé à consulter cette parcelle",
    'ar.edit.error.save.multiParcels': 'Impossible de sauver les informations agronomiques pour certaines parcelles',

    'ar.edit.ferti.forme': 'Forme',
    'ar.edit.ferti.concentration': 'Concentration (%N)',
    'ar.edit.ferti.concentration.placeholder': 'Concentration',

    'ar.edit.vra.infoMobile':
      "Vous avez choisi d'obtenir une carte de modulation, vous la retrouverez automatiquement sur l'application mobile.",
    'ar.edit.vra.console': 'Souhaitez-vous, en plus, un fichier à insérer dans votre console pour cette parcelle ?',
    'ar.edit.vra.console.header': 'Fichier console ?',
    'ar.edit.vra.console.marque': 'Marque de console',
    'ar.edit.vra.console.marque.other': 'Autre marque',
    'ar.edit.vra.console.marque.header': 'Console',
    'ar.edit.vra.console.version': 'Version de console',
    'ar.edit.vra.console.version.warning': "Renseigner d'abord la marque",
    'ar.edit.vra.console.version.header': 'Version',
    'ar.edit.vra.console.version.other': 'Autre version',
    'ar.edit.vra.console.version.free': 'Préciser la version de console',
    'ar.edit.vra.console.version.free.placeholder': 'Version de la console',
    'ar.edit.vra.console.format': 'Format',
    'ar.edit.vra.console.format.nonConnu': 'Non connu',
    'ar.edit.vra.console.format.warning': "Renseigner d'abord la marque et la version",

    'ar.edit.verse.choix': "Souhaitez-vous bénéficier d'une évaluation du risque de verse ?",
    'ar.edit.verse.choix.title': 'Verse ?',
    'ar.edit.verse.apportMO': 'Apport de matière organique',
    'ar.edit.verse.apportMO.tooltip':
      "En cas d'apport de produit organique sur la culture en fin d'été ou à l'automne, que ce soit avant le semis ou en végétation, indiquez le type de produit épandu. Compte-tenu de la forte variabilité des compositions moyennes des produits et des pratiques d'épandage, il est conseillé d'utiliser des valeurs mesurées. Si vous ne disposez pas d'analyses, des valeurs par défaut seront utilisées.",
    'ar.edit.verse.apport.mo.automne': "Nombre d'apports de matière organique à l'automne",
    'ar.edit.verse.apport.mo.automne.choix': "Nombre d'apports",
    'ar.edit.verse.frequence': "Fréquence d'apport",
    'ar.edit.verse.frequence.choix': 'Fréquence',
    'ar.edit.verse.apports.mineraux': 'Apports minéraux',
    'ar.edit.verse.apports.mineraux.fractionnement': 'Fractionnement des apports minéraux',
    'ar.edit.verse.apports.mineraux.fractionnement.choix': 'Fractionnement',
    // TODO suppr verse inutiles
    'ar.edit.verse.apportMo.1': '1er Apport',
    'ar.edit.verse.produit': 'Produit',
    'ar.edit.verse.periode': "Période d'apport",
    'ar.edit.verse.periode.title': 'Période',
    'ar.edit.verse.teneur': 'Teneur en azote (kgN/t ou kgN/m³)',
    'ar.edit.verse.apportMo.1.teneur.placeholder': 'Teneur (1er apport)',
    'ar.edit.verse.quantite': 'Quantité de produit épandue (t/ha ou m³/ha)',
    'ar.edit.verse.apportMo.1.quantite.placeholder': 'Quantité de produit (1er apport)',
    'ar.edit.verse.apportMo.2': '2ème Apport',
    'ar.edit.verse.apportMo.2.teneur.placeholder': 'Teneur (2ème apport)',
    'ar.edit.verse.apportMo.2.quantite.placeholder': 'Quantité de produit (2ème apport)',
    'ar.edit.verse.historique': 'Historique des apports de matière organique',
    'ar.edit.verse.historique.tooltip':
      "Il s'agit de l'historique des apports de produits organiques sur la parcelle sur les quelques années précédentes.",

    'ar.edit.verse.historique.produit': 'Produit généralement apporté',
    'ar.edit.verse.historique.produit.tooltip':
      'Dans le cas où plusieurs types de produits sont apportés, privilégiez les produits à décomposition lente comme les fumiers et les composts.',
    'ar.edit.verse.historique.produit.choix': 'Produit',

    'ar.colza.gc.choix': 'Choix du passage',
    'ar.colza.gc.choix.colzaeh': '1er apport minéral en Sortie Hiver',
    'ar.colza.gc.choix.colzash': 'Dernier apport minéral en Sortie Hiver',

    'ar.ble.gc.choix': 'Choix du passage',
    'ar.ble.gc.choix.t1': 'Tallage',
    'ar.ble.gc.choix.t2': 'Début montaison',
    'ar.ble.gc.choix.2n': 'Fin montaison 2N',
    'ar.ble.gc.choix.t3': 'Fin montaison 3N ou DFE',

    'ar.orge.gc.choix': 'Choix du passage',
    'ar.orge.gc.choix.t2': 'Début montaison',
    'ar.orge.gc.choix.t3': 'Fin montaison',

    'ar.gc.title': 'Génération de fichiers de modulation',
    'ar.gc.button.next': 'Étape suivante',
    'ar.gc.button.back': 'Retour',
    'ar.gc.button.validate': 'Valider',
    'ar.gc.button.gen': 'Générer les fichiers',
    'ar.gc.error.sauverDoses': 'Impossible de sauver les doses',
    'ar.gc.error.sauverConsoles': 'Impossible de sauver les consoles',
    'ar.gc.genSuccess': 'Les fichiers ont été générés avec succès !',
    'ar.gc.error.genError': 'Impossible de générer les fichiers ! Veuillez contacter le support client.',
    'ar.gc.error.unauthorized': "Vous n'êtes pas autorisé à modifier ces consoles",
    'ar.gc.error.recupDoses': 'Erreur lors de la récupération des doses !',
    'ar.gc.noParcelles': 'Aucune parcelle à afficher',

    'ar.gc.fd.title': 'Choix de la dose pour fichier console',
    'ar.gc.fd.parcelle': 'Parcelle',
    'ar.gc.fd.dosePreco': 'Dose préconisée',
    'ar.gc.fd.doseConsole': 'Dose pour fichier console',

    'ar.gc.gp.title': 'Facultatif - Fusion des parcelles',
    'ar.gc.gp.subtitle': 'Fusion de plusieurs fichiers en un dans le cas de parcelles contigües',
    'ar.gc.gp.solid': 'Solide',
    'ar.gc.gp.liquid': 'Liquide',
    'ar.gc.gp.warning.rds':
      'Les fichiers RDS ne pourront pas être générés via cette interface. Contacter le support pour obtenir un fichier au format RDS.',
    'ar.gc.gp.warning.teejetChallenger':
      'Les fichiers pour consoles Teejet, Challenger, Valtra et Massey Ferguson ne pourront pas être générés via cette interface. Contacter le support pour obtenir un fichier pour ces consoles.',
    'ar.gc.gp.warning.amatron4':
      "Les fichiers pour la version Amatron 4 d'Amazone ne pourront pas être générés via cette interface. Contacter le support pour obtenir un fichier pour ces consoles.",
    'ar.gc.gp.warning.fertilizer': 'à renseigner',
    'ar.gc.gp.parcelle': 'Parcelle',
    'ar.gc.gp.groupe': 'Groupe',
    'ar.gc.gp.noGroupe': 'Aucun groupe',
    'ar.gc.gp.noFusion': 'Pas de fusion possible',
    'ar.gc.gp.groupe.base': 'Groupe',

    'ar.gc.launcher.title': 'Lancement de la génération des fichiers console',
    'ar.gc.launcher.text.1':
      'Cliquer sur "Générer les fichiers" pour lancer la génération des fichiers console. Cette étape pourra prendre plusieurs minutes.',
    'ar.gc.launcher.text.2': "Merci de ne pas fermer la fenêtre du navigateur jusqu'à la fin du traitement !",
    'ar.gc.launcher.text.3.p1': 'Les fichiers générés seront disponibles sur la page des',
    'ar.gc.launcher.text.3.p2': 'conseils',

    'ar.gc.sc.dialog.title': 'Console et engrais pour la parcelle',
    'ar.gc.sc.dialog.console': 'Fichier console',
    'ar.gc.sc.dialog.engrais': "Apports d'engrais minéral",

    'ar.gc.sc.title': "Vérification des consoles et des types d'engrais",
    'ar.gc.sc.error.consoles': 'Erreur lors de la récupération des consoles !',
    'ar.gc.sc.unknown': 'Non connu',
    'ar.gc.sc.other.marque': 'Autre marque',
    'ar.gc.sc.other.version': 'Autre version',
    'ar.gc.sc.parcelle': 'Parcelle',
    'ar.gc.sc.console': 'Console',
    'ar.gc.sc.engrais': 'Engrais',
    'ar.gc.sc.button.modiferSelection': 'Modifier la sélection',

    'ar.gc.sf.title': 'Choix des exploitations',
    'ar.gc.sf.noParcelles': 'Aucune parcelle disponible pour la génération de fichier !',
    'ar.gc.sf.error.exploitations': 'Erreur lors de la récupération des exploitations !',
    'ar.gc.sf.warning':
      "Les exploitations qui s'affichent ne sont que les exploitations pour lesquelles les conseils sont disponibles et pour lesquelles une console est renseignée dans la commande.",
    'ar.gc.sf.filter.exploitation.placeholder': "nom de l'exploitation",
    'ar.gc.sf.filter.distributeur': 'Distributeur',
    'ar.gc.sf.noExploitations': 'Aucune exploitation à afficher',
    'ar.gc.sf.nom': 'Nom',
    'ar.gc.sf.ville': 'Ville',

    'ar.order.section': 'Commandes passées',
    'ar.order.table.filter.exploitations': 'Filtrer par exploitation',
    'ar.order.table.filter.campagne': 'Filtrer par campagne',
    'ar.order.table.filter.campagne.base': 'Campagne',
    'ar.order.table.filter.distributeur': 'Distributeur',
    'ar.order.table.distributeur': 'Distributeur',
    'ar.order.table.date': 'Date',
    'ar.order.table.numParcelles': 'Quantité de Parcelles',
    'ar.order.table.utilisateurs': 'Utilisateurs',
    'ar.order.table.exploitations': 'Exploitations',
    'ar.order.table.edit': (specyString: string) => 'Editer cette commande de conseil ' + specyString,
    'ar.order.table.delete': (specyString: string) =>
      'Supprimer définitivement cette commande de conseil ' + specyString,
    'ar.order.table.view': (specyString: string) => 'Voir cette commande de conseil ' + specyString,
    'ar.order.error.load': 'Impossible de récupérer les commandes',
    'ar.order.delete.confirm': 'Etes-vous certain de bien vouloir supprimer définitivement cette commande ?',
    'ar.order.error.delete': (specyString: string) => 'Impossible de supprimer la commande ' + specyString,
    'ar.order.error.unauthorized': "Vous n'êtes pas autorisé à visualiser cette information",

    'ar.order.total': 'Total commandé',
    'ar.order.total.space': '      ',
    // TODO remplacer les 2 par function prenant le num de parcelles en arg
    'ar.order.total.parcelles': 'Parcelles',
    'ar.order.total.parcelles.number': 'parcelles',
    'ar.order.total.surface': 'Surface',

    'ar.order.edit.edition': 'Edition de la commande',
    'ar.order.edit.view': 'Détails de la commande',
    'ar.order.edit.creation': "Ajout d'une commande",
    'ar.order.edit.nom': 'Nom',
    'ar.order.edit.ville': 'Ville',
    'ar.order.edit.surface': 'Surface',
    'ar.order.edit.button.delete.tooltip': 'Enlever cette parcelle de la commande',
    'ar.order.edit.button.back': 'Retour',
    'ar.order.edit.button.confirm': 'Confirmer la commande',
    'ar.order.edit.prompt.delete': "La commande n'a plus de parcelles. Voulez-vous la supprimer ?",
    'ar.order.edit.prompt.confirmation':
      "Votre commande a bien été prise en compte. N'oubliez pas de renseigner les dates de livraisons souhaitées dans l'onglet Mon planning.",
    'ar.order.edit.error.load': 'Impossible de charger la commande',
    'ar.order.edit.wait': 'Votre commande est en cours de vérification',
    'ar.order.edit.error.hasOrder':
      'Certaines des parcelles sélectionnées sont déjà commandées; veuillez les retirer de la liste avant de passer commande\n',
    'ar.order.edit.error.orderItem':
      'Certaines des parcelles sélectionnées ne peuvent être commandées; veuillez saisir les informations agronomiques avant de passer commande\n',
    'ar.order.edit.error.loadInfoParcelles': (specyString: string) =>
      `Impossible de charger les informations ${specyString} des parcelles`,
    'ar.order.edit.delete.confirm':
      'Etes-vous certain de bien vouloir retirer définitivement cette parcelle de la commande ?',
    'ar.order.edit.unauthorized': "Vous n'êtes pas autorisé à modifier cette commande",
    'ar.order.edit.unauthorized.view': "Vous n'êtes pas autorisé à consulter cette commande",

    'ar.result.dialog.title': 'Envoi du conseil par email',
    'ar.result.dialog.confirm': "Confirmez-vous l'envoi par email du fichier sélectionné ?",
    'ar.result.dialog.confirm.plural': "Confirmez-vous l'envoi par email des fichiers sélectionnés ?",
    'ar.result.dialog.confirm.destinataire': 'Destinataire du fichier',
    'ar.result.dialog.confirm.destinataire.plural': 'Destinataires des fichiers',
    'ar.result.dialog.confirm.destinataire.agri': 'Agriculteurs',
    'ar.result.dialog.confirm.destinataire.conseiller': 'Conseillers',
    'ar.result.dialog.confirm.destinataire.respDistr': 'Responsables de distributeur',

    'ar.result.table.filter.parcelle.placeholder': 'parcelle',
    'ar.result.table.filter.exploitation.placeholder': 'exploitation',
    'ar.result.table.filter.id.placeholder': 'identifiant',
    'ar.result.table.filter.conseiller.placeholder': 'login du conseiller',
    'ar.result.table.filter.type': 'Type de fichiers',
    'ar.result.table.filter.campagne': 'Campagne',
    'ar.result.table.filter.distributeur': 'Distributeur',
    'ar.result.table.filter.validation': 'Validation',
    'ar.result.table.filter.validation.choice.valide': 'Validé',
    'ar.result.table.filter.validation.choice.nonValide': 'Non validé',
    'ar.result.table.filter.visibilite': 'Visibilité',
    'ar.result.table.filter.visibilite.choice.visible': 'Visible par les utilisateurs',
    'ar.result.table.filter.visibilite.choice.nonVisible': 'Non visible',
    'ar.result.table.filter.envoi.conseillers': 'Envoi conseillers',
    'ar.result.table.filter.envoi.agri': 'Envoi',
    'ar.result.table.filter.envoi.agri.wanaka': 'Envoi agriculteurs',
    'ar.result.table.filter.envoi.choice.envoye': 'Envoyé',
    'ar.result.table.filter.envoi.choice.nonEnvoye': 'Non envoyé',
    'ar.result.table.button.telecharger': 'Télécharger',
    'ar.result.table.button.valider': 'Valider',
    'ar.result.table.button.disponible': 'Rendre disponible',
    'ar.result.table.button.envoyer': 'Envoyer par email',
    'ar.result.table.tooltip.batch':
      "Ces boutons permettent d'effectuer la même action sur TOUS les fichiers sélectionnés.",
    'ar.result.table.button.genConsole': 'Générer un fichier console',
    'ar.result.table.tooltip.genConsole':
      'Cliquer sur ce bouton pour générer un fichier console (avec ou sans fractionnement)',
    'ar.result.table.date': 'Date',
    'ar.result.table.nom': 'Nom',
    'ar.result.table.exploitation': 'Exploitation',
    'ar.result.table.conseil': 'Conseil',
    'ar.result.table.valide': 'Validé',
    'ar.result.table.disponible': 'Disponible',
    'ar.result.table.admin': 'Admin',
    'ar.result.table.envoye': 'Envoyé',
    'ar.result.table.suppr.column': 'Supprimer',
    'ar.result.table.telecharger.column': 'Télécharger',
    'ar.result.table.button.valider.row': 'Valider',
    'ar.result.table.button.invalider': 'Invalider',
    'ar.result.table.button.public': 'Rendre public',
    'ar.result.table.button.cacher': 'Cacher',
    'ar.result.table.button.envoyer.row': 'Envoyer',
    'ar.result.table.button.invaliderEnvoi': "Invalider l'envoi",
    'ar.result.table.button.suppr': 'Supprimer',
    'ar.result.table.button.telecharger.row': 'Télécharger',
    // le HTML est passé depuis JS donc pas besoin de unsafe
    'ar.result.table.warning.notSent':
      "- Vérifier que les conseils sélectionnés n'ont pas déjà été envoyés<br/> - Vérifier que les conseils sélectionnés sont validés",
    'ar.result.table.error.invalider': "Impossible d'invalider ce fichier",
    'ar.result.table.error.valider': 'Impossible de valider ce fichier',
    'ar.result.table.error.cacher': 'Impossible de cacher ce fichier',
    'ar.result.table.error.public': 'Impossible de rendre public ce fichier',
    'ar.result.table.confirm.invaliderEnvoi': "Confirmez-vous l'invalidation de l'envoi du fichier ?",
    'ar.result.table.error.invaliderEnvoi': "Impossible d'invalider l'envoi du fichier",
    'ar.result.table.confirm.invaliderEnvoi.conseillers':
      "Confirmez-vous l'invalidation de l'envoi du fichier aux conseillers ?",
    'ar.result.table.error.invaliderEnvoi.conseillers': "Impossible d'invalider l'envoi du fichier aux conseillers.",
    'ar.result.table.confirm.suppr': 'Confirmez-vous la suppression du fichier ?',
    'ar.result.table.error.suppr': 'Impossible de supprimer ce fichier',
    'ar.result.table.error.telecharger': 'Impossible de télécharger le fichier',
    'ar.result.table.confirm.disponible': 'Confirmez-vous la mise à disposition des fichiers sélectionnés ?',
    'ar.result.table.error.disponible': 'Impossible de mettre à disposition ces fichiers',
    'ar.result.table.confirm.valider': 'Confirmez-vous la validation des fichiers sélectionnés ?',
    'ar.result.table.error.valider.plural': 'Impossible de valider ces fichiers',
    'ar.result.table.error.envoi': "Une erreur est survenue lors de l'envoi des conseils",
    'ar.result.table.warning.envoi': (numResultsFound: number) =>
      'Seuls ' + numResultsFound + ' conseil(s) parmi ceux sélectionnés ont été envoyés !<br/> ',
    'ar.result.table.envoi.success': 'Les conseils sélectionnés ont été envoyés !',
    'ar.result.table.error.envoi.none': "Aucun conseil ne correspond aux critères pour l'envoi !<br/> ",
    'ar.result.table.error.unauthorized': "Vous n'êtes pas autorisé à faire cette opération",
    'ar.result.table.error.select': 'Impossible de sélectionner les fichiers',

    'ar.report.title': 'Rapport de campagne',
    'order.delete.error.dialogTitle': 'Statut de suppression des éléments de commande',
    'order.delete.error.summary': (params: { count?: number } = {}) => {
      const count = params && typeof params.count === 'number' ? params.count : 0;
      return count === 1
        ? "1 suppression d'élément de commande a échoué."
        : `${count} suppressions d'éléments de commande ont échoué.`;
    },
    'order.delete.success.summary': (params: { count?: number } = {}) => {
      const count = params && typeof params.count === 'number' ? params.count : 0;
      return count === 1
        ? '1 élément de commande a été supprimé avec succès.'
        : `${count} éléments de commande ont été supprimés avec succès.`;
    },
    'order.delete.error.parcelIdNull': "L'identifiant de la parcelle ne peut pas être nul.",
    'order.delete.error.parcelNotFound': 'Parcelle introuvable.',
    'order.delete.error.noOrderItem': "La parcelle n'a pas d'élément de commande à supprimer.",
    'order.delete.error.adviceAlreadyRequested': () =>
      "Impossible de supprimer l'élément de commande : conseil déjà demandé.",
    'order.delete.error.passageAlreadyRestituted': () =>
      "Impossible de supprimer l'élément de commande : le passage a déjà été restitué.",
    'order.delete.error.personalizedDateTooSoon': () =>
      "Impossible de supprimer l'élément de commande : la date personnalisée doit être dans plus de 3 jours.",
    'order.delete.error.defaultWeekInPast': () =>
      "Impossible de supprimer l'élément de commande : la semaine par défaut est dans le passé.",
    'order.delete.error.defaultWeekTooClose': () =>
      "Impossible de supprimer l'élément de commande : la semaine par défaut est trop proche pour être supprimée.",
    'ar.report.filter': 'Campagne',
    'ar.report.button.telecharger': 'Télécharger',
    'ar.report.table.exploitation': 'Exploitation',
    'planning.date.error.delivered':
      'La date de livraison personnalisée ne peut pas être modifiée car la parcelle a déjà été livrée',
    'planning.success.suspend.message':
      'Les livraisons de {{successfulCount}} parcelles sur {{totalParcels}} ont été suspendues',
    'planning.success.reactivate.message':
      'Les livraisons de {{successfulCount}} parcelles sur {{totalParcels}} ont été réactivées',
    'planning.error.noSuspensions.message': "Aucune parcelle n'a pu être suspendue",
    'planning.error.noReactivations.message': "Aucune parcelle n'a pu être réactivée",
    'planning.multipleSelection.warning.title': 'Multisélection',
    'planning.multipleSelection.warning.message': 'Attention toutes les parcelles sélectionnées seront modifiées',
    'planning.error.outsideCampaign.message': 'Hors plage des jours de campagne',
    'planning.error.adviceDelivered.message': 'Le conseil a été livré',
    'planning.error.multipleFailures.title': 'Erreurs de sélection multiples',
    'planning.error.singleParcel.title': 'Erreur dans la parcelle',
    'planning.batchUpdate.resultsTitle': 'Statut de mise à jour',
    'planning.error.noDefaultWeek.message': "la semaine par défaut n'a pas été définie",
    'planning.error.defaultWeekSuspendLimit.message':
      "Vous ne pouvez cocher la case suspension que jusqu'au vendredi précédant la semaine de livraison par défaut",
    'planning.error.suspendBeforeLimit.message':
      "Vous ne pouvez cocher la case suspension que jusqu'à 3 jours avant la date de livraison personnalisée",
    'planning.error.parcels': 'parcelle/s',
    'planning.success.dateUpdates': 'Parcelles avec des dates mises à jour avec succès.',
    'planning.error.failedDateUpdates': "parcelles n'ont pas pu être modifiées car les conseils sont déjà restitués.",
    'planning.success.suspensions': 'Parcelles mises à jour avec succès suite à suspension.',
    'planning.error.failedSuspensions': "Parcelles n'ont pas pu être mises à jour en raison de la suspension.",
    // Messages for planning matrix decision
    'planning.message.Title': 'Statut de mise à jour',
    'planning.suspend.error.pastWeek':
      "{{count}} parcelle/s n'ont pas pu être suspendues car la date de planification est déjà passée.",
    'planning.suspend.error.pastDate':
      "{{count}} parcelle/s n'ont pas pu être suspendues car la date de planification est déjà passée.",
    'planning.suspend.error.pastDateWeek':
      "{{count}} parcelle/s n'ont pas pu être suspendues car la date de planification est déjà passée.",
    'planning.suspend.error.restituted':
      "{{count}} parcelle/s n'ont pas pu être suspendues car les conseils sont déjà restituées.",
    'planning.reactivate.error.restituted':
      "{{count}} parcelle/s n'ont pas pu être réactivées car les conseils sont déjà restituées.",
    'planning.reactivate.error.restituted.pastWeek':
      "{{count}} parcelle/s n'ont pas pu être réactivées car les conseils sont déjà restituées et la date de planification est déjà passée.",
    'planning.suspend.error.restituted.pastWeek':
      "{{count}} parcelle/s n'ont pas pu être suspendues car les conseils sont déjà restituées et la date de planification est déjà passée.",
    'planning.suspend.success': 'La suspension a bien été prise en compte.',
    'planning.reactivate.error.campaign':
      "{{count}} parcelles n'ont pas pu être réactivées car la fin de la campagne a été atteinte.",
    'planning.reactivate.success': 'La réactivation a bien été prise en compte.',
    'planning.reactivate.dateUnset.success':
      'La réactivation a bien été prise en compte.<br>{{count}} parcelle/s ont été replanifiées à J+3',
    // Messages for planning matrix decision for singular messages
    'planning.suspend.error.pastWeek.singular':
      "{{count}} parcelle n'a pas pu être suspendue car la date de planification est déjà passée.",
    'planning.suspend.error.pastDate.singular':
      "{{count}} parcelle n'a pas pu être suspendue car la date de planification est déjà passée.",
    'planning.suspend.error.pastDateWeek.singular':
      "{{count}} parcelle n'a pas pu être suspendue car la date de planification est déjà passée.",
    'planning.suspend.error.restituted.singular':
      "{{count}} parcelle n'a pas pu être suspendue car les conseils sont déjà restitués.",
    'planning.reactivate.error.restituted.singular':
      "{{count}} parcelle n'a pas pu être réactivée car les conseils sont déjà restitués.",
    'planning.reactivate.error.restituted.pastWeek.singular':
      "{{count}} parcelle n'a pas pu être réactivée car les conseils sont déjà restitués et la date de planification est déjà passée.",
    'planning.suspend.error.restituted.pastWeek.singular':
      "{{count}} parcelle n'a pas pu être suspendue car les conseils sont déjà restitués et la date de planification est déjà passée.",
    'planning.suspend.success.singular': 'La suspension a bien été prise en compte.',
    'planning.reactivate.error.campaign.singular':
      "{{count}} parcelle n'a pas pu être réactivée car la fin de la campagne a été atteinte.",
    'planning.reactivate.success.singular': 'La réactivation a bien été prise en compte.',
    'planning.reactivate.dateUnset.success.singular':
      'La réactivation a bien été prise en compte.<br>{{count}} parcelle a été replanifiée à J+3',

    'planning.section': 'Mise à jour du planning en',
    'planning.passage.choix': 'Choix du passage',
    'planning.button.back': 'Retour',
    'planning.button.next': 'Étape suivante',
    'planning.button.terminer': 'Terminer',
    'planning.datepicker.parcelles.title': 'Choix des dates pour les parcelles',
    'planning.datepicker.exploitations.title': 'Choix des dates pour les exploitations',
    'planning.date.confirm': 'Changement de la date au',
    'planning.error.date': "La date souhaitée n'est pas disponible",
    'planning.error.date.nonOuvre': '- Vous ne pouvez pas sélectionner un jour non ouvré',
    'planning.error.date.jourPasse': '- Vous ne pouvez pas sélectionner un jour passé',
    'planning.error.date.delai': '- Vous devez respecter un délai de 72h par rapport à la date du jour',
    'planning.error.date.campagne':
      "- La campagne n'est pas ouverte : veuillez contacter le support pour plus d'informations",
    'planning.error.date.campagne.colza':
      "- La campagne n'est pas ouverte. Si vous souhaitez être livré avant la validation Terres Inovia, merci de contacter le support",
    'planning.save': 'Enregistrer et valider',
    'planning.culture.ble': 'Blé',
    'planning.culture.orge': 'Orge',
    'planning.culture.colza': 'Colza',
    'planning.label.ble.t1': 'Tallage',
    'planning.label.ble.t2': 'Début montaison',
    'planning.label.ble.2n': 'Fin montaison - 2 Nœuds',
    'planning.label.ble.t3': 'Fin montaison - 3 Nœuds ou DFE',
    'planning.label.orge.t2': 'Début montaison',
    'planning.label.orge.t3': 'Fin montaison',
    'planning.label.colza.eh': 'Entrée Hiver',
    'planning.label.colza.sh': 'Sortie Hiver',
    'planning.livraison.choix':
      'Souhaitez-vous renseigner la même date de livraison pour toutes les parcelles des exploitations sélectionnées ?',
    'planning.livraison.choix.oui': 'Oui',
    'planning.livraison.choix.non': 'Non',
    'planning.error.parcelles': 'Problème lors de la récupération des parcelles.',
    'planning.error.info': 'Erreur lors de la récupération des informations !',
    'planning.error.unauthorized': "Vous n'êtes pas autorisé à faire cette opération",
    'planning.error.date.range': 'la date de ne peut pas être postérieure à la date de',
    'planning.error.parcellesUpdate': "Problème lors de la récupération des parcelles lors de l'update.",
    'planning.success': (dateStr: string, objectList: string) =>
      'Les dates des parcelles pas encore restituées ont été changées au ' +
      dateStr +
      ' ' +
      objectList +
      '. Actualisez la page si nécessaire.',
    'planning.error.campagne': 'Problème lors de la récupération de la campagne.',

    'planning.info.colza.eh':
      'L’image satellite utilisée pour l’estimation de biomasse Entrée Hiver sera la plus proche du 30 novembre, date fixée par Terres Inovia. Si cette date ne vous convient pas, merci de vous rapprocher du support.',
    'planning.info.colza.sh':
      'Par défaut, pour les conseils colza commandés après le 31 janvier, une image la plus proche du 31 janvier sera utilisée pour l’estimation de la biomasse Sortie Hiver. Si cette date ne vous convient pas, veuillez contacter le support.',

    'planning.exploitations.title': 'Choix des exploitations',
    'planning.exploitations.filter.exploitation': 'Exploitation',
    'planning.exploitations.filter.exploitation.placeholder': "nom de l'exploitation",
    'planning.exploitations.filter.login.placeholder': 'login agri/référent',
    'planning.exploitations.filter.cp.placeholder': 'code postal',
    'planning.exploitations.filter.distr': 'Distributeur',
    'planning.choice.yes': 'Renseignée',
    'planning.choice.no': 'Non renseignée',
    'edit.choice.yes': 'Yes',
    'edit.choice.no': 'No',
    'planning.exploitations.noExploitations': 'Aucune exploitation à afficher',
    'planning.exploitations.nom': 'Nom',
    'planning.exploitations.ville': 'Ville',
    'planning.exploitations.cp': 'Code postal',
    'planning.exploitations.dates': 'Dates renseignées',
    'planning.exploitations.complete': 'complété',
    'planning.exploitations.complete.title': "L'ensemble des dates ont été renseignées.",
    'planning.exploitations.nonComplete': 'non complété',
    'planning.exploitations.nonComplete.title': "L'ensemble des dates ne sont pas renseignées",
    'planning.exploitations.error.noParcelles': 'Aucune parcelle disponible pour ce passage !',
    'planning.exploitations.error.exploitations': 'Erreur lors de la récupération des exploitations !',
    'planning.exploitations.error.selectExploitations': 'Impossible de sélectionner les exploitations',

    'planning.parcelles.title': 'Planification de livraison pour les parcelles',
    'planning.parcelles.filter.parcelle.placeholder': 'nom de la parcelle',
    'planning.parcelles.filter.dateApres': 'Date de semis après le',
    'planning.parcelles.filter.dateApres.placeholder': 'dateApres',
    'planning.parcelles.filter.dateAvant': 'Date de semis avant le',
    'planning.parcelles.filter.dateAvant.placeholder': 'dateAvant',
    'planning.parcelles.filter.id': 'Identifiant',
    'planning.parcelles.filter.date.personalized': 'Date personnalisée',
    'planning.parcelles.date.planning.before': 'Date de livraison avant le',
    'planning.parcelles.date.planning.after': 'Date de livraison après le',
    'planning.parcelles.filter.cp.placeholder': 'code postal',
    'planning.parcelles.filter.id.placeholder': 'identifiant',
    'planning.parcelles.filter.culture': 'Culture',
    'planning.parcelles.filter.destination': 'Destination',
    'planning.parcelles.filter.distr': 'Distributeur',
    'planning.parcelles.filter.suspended': 'Suspendue',
    'planning.parcelles.noParcelles': 'Aucune parcelle à afficher',
    'planning.parcelles.nom': 'Parcelle',
    'planning.parcelles.cp': 'CP',
    'planning.parcelles.dateSemis': 'Semis',
    'planning.parcelles.destination': 'Destination',
    'planning.parcelles.culture': 'Culture',
    'planning.parcelles.dateLivraison': 'Date de livraison personnalisée',
    'planning.parcelles.week.default': 'semaine par défaut',
    'planning.parcelles.button.search': 'Appliquer les filtres',
    'planning.parcelles.button.reset': 'Réinitialiser les filtres',
    'planning.parcelles.action.suspend': 'Suspendre',
    'planning.parcelles.action.modifier.tooltip': 'Modifier',
    'planning.parcelles.action.suspend.tooltip':
      "Il est possible de suspendre une restitution jusqu'à j-3 de la date personnalisée ou fin de semaine précédente à la semaine de restitution par défaut.",
    'planning.parcelles.aRenseigner': 'A renseigner',
    'planning.parcelles.button.modifierSelection': 'Modifier la sélection',
    'planning.parcelles.pagination.page': 'page',
    'planning.parcelles.pagination.previous': 'précédente',
    'planning.parcelles.pagination.next': 'suivante',
    'planning.parcelles.error.impossible.tooltip':
      "Impossible d'effectuer cette action. La date de livraison est trop proche ou déjà passée.",
    'planning.parcelles.error.parcelles': 'Problème dans la récupération des parcelles',
    'planning.parcelles.error.noParcelles': 'Aucune parcelle disponible pour ce passage !',
    'planning.parcelles.error.parcelles.2': 'Erreur lors de la récupération des parcelles !',
    'planning.parcelles.error.selectParcelles': 'Impossible de sélectionner les parcelles',
    'planning.parcelles.error.cultures': 'Problème lors de la récupération des cultures.',

    'exports.section': 'Exports',
    'exports.section.intro': 'Cette page regroupe les différents exports mis à disposition des utilisateurs.',
    'exports.commandes': (productName: string) => 'Export des commandes ' + productName,
    'exports.commandes.fileName.part': 'commandes',
    'exports.resultats': (productName: string) => 'Export des résultats ' + productName,
    'exports.resultats.fileName.part': 'resultats',
    'exports.summary': 'Synthèse des résultats au format PDF',
    'exports.summary.user.message':
      'Votre demande a bien été prise en compte.\nLe document synthèse d’exploitation est en cours de génération.\nVous le recevrez par e-mail à l’adresse #mailuser dans l’heure qui suit.',
    'exports.summary.error': 'Erreur lors de la génération du Synthèse',
    'exports.summary.conflict.error':
      "Un document synthèse d'exploitation est déjà en cours de création.\nMerci d'attendre la réception de ce document sur votre adresse email {email}\navant de demander la génération d'un nouveau document.",
    'exports.telecharger': 'Télécharger',
    'exports.campagne': 'Campagne',
    'exports.error.telecharger': 'Une erreur est survenue, veuillez contacter le support',

    'machininisme.info.1':
      "Cette page regroupe les notices d'utilisation des consoles de plusieurs constructeurs. Elle n'est pas exhaustive.",
    'machininisme.info.2':
      'Vous pouvez également télécharger ci-dessous notre tutoriel vidéo qui explique la démarche à suivre pour intégrer les fichiers de modulation dans votre console.',
    'machininisme.tutoriel': 'Tutoriel',
    'machininisme.button.telecharger': 'Télécharger',
    'machininisme.noNotice': 'Aucune notice à afficher',
    'machininisme.constructeur': 'Constructeur',
    'machininisme.notice': 'Notice',
    'machininisme.error.telecharger': 'Impossible de télécharger le fichier',
    'machininisme.error.unauthorized': "Vous n'êtes pas autorisé à faire cette opération",

    'campaign.status.configure': 'Configuré',
    'campaign.status.nonConfigure': 'Non configuré',

    'edit.choice.none': 'Aucun',
    'edit.choice.all': 'TOUS',
    // TODO fen / masc => utiliser fonction ; pour l'instant : le fem concerne le francais uniquement
    // ou avoir un all diff pour tous les types possibles de All
    'edit.choice.all.fem': 'TOUTES',
    'edit.section.creation': 'Création',
    'edit.section.creation.fieldview': 'Importer les données de Fieldview',
    'edit.error.generic': 'Il y a des erreurs dans le formulaire',
    'error.generic': 'Une erreur est survenue',
    'table.reference': 'Référence',
    'table.itemsPerPage': "Nombre d'éléments par page :",

    'table.filter.button.autres': 'Autres filtres',
    'table.filter.button.reinit': 'Réinitialiser les filtres',
    'table.filter.button.reinit.singular': 'Réinitialiser le filtre',

    'button.edit': 'Editer',
    'button.save': 'Enregistrer',
    'button.modify': 'Modifier',
    'button.confirm': 'Confirmer',
    'button.cancel': 'Annuler',
    'button.fichier': 'Choisir un fichier',

    // Planning Visualizer
    'planning.visualizer.title': (currentYear: number) => `MON PLANNING <b>${currentYear}</b>`,
    'planning.visualizer.breadcrumb': (params) => `MON PLANNING ${params.year}`,
    'planning.visualizer.legend.defaultDate': 'Date par défaut',
    'planning.visualizer.legend.personalizedDate': 'Date personnalisée',
    'planning.visualizer.legend.note': "*Le chiffre à l'intérieur indique le nombre de parcelles",

    'planning.visualizer.filters.distributor': 'Distributeur',
    'planning.visualizer.filters.advisorLogin': 'Login du conseiller',
    'planning.visualizer.filters.exploitation': 'Exploitation',
    'planning.visualizer.filters.applyFilters': 'Appliquer les filtres',
    'planning.visualizer.filters.resetFilters': 'Réinitialiser les filtres',
    'planning.visualizer.filters.viewParcels': 'Visualiser toutes mes parcelles',
  }),
);

// TODO images => page d'accueil

// pas de conversion : unités françaises défaut
export const UNIT_CONVERTER = (baseUnit: string, ha: number) => {
  return ha;
};

export const CONVERTED_UNIT = (baseUnit: string, isPlural = false) => {
  return baseUnit;
};

export const NUMBER_FORMATTER = (n: number, options: any) => {
  return n.toLocaleString('fr', options);
};

export const DATE_FORMATTER = (d: Date) => {
  return d.toLocaleDateString('fr');
};

// TODO revoir ; trop simple ? mais OK pour FR et EN
export const PUNCTUATION_FORMATTER = (s: string) => {
  if (s == ':' || s == ';' || s == '!' || s == '?') {
    return ' ' + s;
  }
  return s;
};
